<template>
  <b-modal
    :title="title"
    cancel-title="Anuluj"
    v-model="modalShow"
    @hidden="resetModal"
    @ok="onSubmit"
  >
    <b-form @submit.prevent="onSubmit">
      <b-form-group label="Data rozpoczęcia urlopu" class="required">
        <date-picker
          v-model="startDate"
          :config="options"
          language="pl"
          autocomplete="off"
          :class="{'is-invalid': $v.startDate.$error}"
        ></date-picker>
        <b-form-invalid-feedback v-if="!$v.startDate.required">To pole jest wymagane</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Data zakończenia urlopu (włącznie)" class="required">
        <date-picker
          v-model="endDate"
          :config="options"
          language="pl"
          autocomplete="off"
          :class="{'is-invalid': $v.endDate.$error}"
        ></date-picker>
        <b-form-invalid-feedback v-if="!$v.endDate.required">To pole jest wymagane</b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      modalShow: false,

      id: null,
      startDate: null,
      endDate: null,

      options: {
        format: "YYYY-MM-DD",
        locale: "pl",
        useCurrent: true
      }
    };
  },
  computed: {
    title() {
      return this.id ? "Zmień  urlop" : "Dodaj urlop";
    }
  },
  validations: {
    startDate: {
      required
    },
    endDate: {
      required
    }
  },
  methods: {
    showModal(id) {
      if (id) {
        axios
          .get("/freeDays/details", {
            params: {
              id: id
            }
          })
          .then(response => {
            let result = response.data;

            this.id = id;
            this.startDate = result.startDate;
            this.endDate = result.endDate;

            this.modalShow = true;
          })
          .catch(error => eventBus.$emit("unhandled-error", error));
      } else {
        this.modalShow = true;
      }
    },
    resetModal() {
      this.id = null;
      this.startDate = null;
      this.endDate = null;
      this.$v.$reset();
    },
    onSubmit(bvModalEvt) {
      this.$v.$touch();
      bvModalEvt.preventDefault();

      if (!this.$v.$error) {
        axios[this.id ? "put" : "post"]("/freeDays", {
          userId: this.userId,
          id: this.id,
          startDate: this.startDate,
          endDate: this.endDate
        })
          .then(() => {
            eventBus.$emit(
              "notify-success",
              this.id ? "Zmieniono urlop" : "Dodano nowy urlop"
            );
            this.$emit("submitted");
            this.modalShow = false;
          })
          .catch(error => eventBus.$emit("unhandled-error", error));
      }
    }
  },
  props: {
    userId: String
  }
};
</script>

<style lang="scss" scoped>
</style>